// extracted by mini-css-extract-plugin
export const topLine = "header-module--top-line--1mIk8";
export const logo = "header-module--logo--tOLth";
export const navigation = "header-module--navigation--3c-sy";